<template>
  <div>
    <!-- <Breadcrumb :options="crumbOptions"></Breadcrumb> -->
    <div class="backStack-issue-wrap informationCreate">
      <From
        ref="form"
        layoutType="grid"
        :isErrorMessage="false"
        :optionList="formRows"
        :formRules="formRules"
        :defaultModel="defaultModel"
      >
      </From>
      <div class="backStack-issue-footer-wrap">
        <div class="submit-wrap">
          <a-button class="submit-audit" @click="invokeApi" :loading="loading"
            >保存并发布</a-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Breadcrumb from '@/components/common/Breadcrumb'
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { formRules, formRows } from './configs/configs.js'
import { getDetail, editInfos } from '@/api/announceApi.js'
import { getCurrentCrumb } from '@/utils/crumb.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: false,
      crumbOptions: [],
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {}, // 默认值
      editId: null
    }
  },
  components: {
    From
    // Breadcrumb
  },
  created() {
    this.initSetting()
  },
  methods: {
    initSetting() {
      const { id } = this.$route.query
      this.editId = id
      this.getAnnounceInfos(id)
    },
    // 单独获取编辑
    async getAnnounceInfos(id) {
      const { data } = await getDetail(id)
      const { fileAnnes, fileVo, ...otherParams } = data
      this.defaultModel = {
        ...otherParams,
        annexIds: fileAnnes,
        picPath: fileVo
      }
    },
    // 处理面包屑
    settingCrumb(type) {
      const { path } = this.$route
      const newPath = path.replace('operation', type)
      const crumbOptions = getCurrentCrumb(newPath)
      this.crumbOptions = crumbOptions
    },
    clearForm() {
      this.defaultModel = { operationType: '1' }
    },
    async invokeApi() {
      const ref = this.$refs.form
      const validate = ref.validatedForm() // 校验表单是否有填写
      if (!validate) return

      try {
        const { picPath, ...formModel } = ref.formModel

        const pic = this.handlerPicPathIds(picPath).join(',')
        const annexIds = this.handlerAnnexIds(formModel).join(',')
        let params = {
          annexIds,
          pic,
          id: this.editId,
          status: '1',
          title: formModel.title
        }
        const { code, msg } = await editInfos(params)
        this.$apiStatusHandler(code, msg)
        this.$router.push({ name: 'informationAnnounce' })
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      } finally {
        this.loading = false
      }
    },
    handlerAnnexIds(instance) {
      const { annexIds } = instance
      if (!annexIds) return []
      return annexIds.reduce((pre, item) => {
        if (item.response) {
          const { fileId } = item.response.data[0]
          pre.push(fileId)
        } else {
          pre.push(item.id)
        }
        return pre
      }, [])
    },
    handlerPicPathIds(picPath) {
      if (!picPath) return []
      return picPath.reduce((pre, item) => {
        if (item.response) {
          const { fileId } = item.response.data[0]
          pre.push(fileId)
        } else {
          pre.push(item.id)
        }
        return pre
      }, [])
    }
  }
}
</script>
